
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaUser, FaLock } from "react-icons/fa";
// import A1 from "../Images/logo-w.png";
// import Select from "react-select";
// import axios from "axios";

// const WhatsappLogin = () => {
//     const [email_id, setEmailId] = useState("");
//     const [password, setPassword] = useState("");
//     const [error, setError] = useState("");
//     const [success, setSuccess] = useState("");
//     const [users, setUsers] = useState([]);
//     const [selectedEmpId, setSelectedEmpId] = useState(null);
//     const [selectedEmpName, setSelectedEmpName] = useState("");
//     const [selectedEmail, setSelectedEmail] = useState("");

//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const response = await fetch("https://erpapi.emedha.in/pages/api/user");
//                 const result = await response.json();
//                 if (response.ok) {
//                     setUsers(result.users);
//                 } else {
//                     setError("Error fetching users");
//                 }
//             } catch (err) {
//                 setError("There was an error fetching the users");
//             }
//         };
//         fetchUsers();
//     }, []);

//     const handleEmpIdChange = (selectedOption) => {
//         const empId = selectedOption ? selectedOption.value : "";
//         setSelectedEmpId(empId);
//         const selectedUser = users.find((user) => user.Emp_id === parseInt(empId));
//         if (selectedUser) {
//             setSelectedEmpName(selectedUser.Emp_Name);
//             setSelectedEmail(selectedUser.email_id);
//             setEmailId(selectedUser.email_id);
//         } else {
//             setSelectedEmpName("");
//             setSelectedEmail("");
//             setEmailId("");
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const loginData = { email_id, password };

//         if (email_id === "admin.erp@gmail.com" && password === "admin") {
//             const userData = { email: email_id, name: "Admin", role: "admin" };
//             const token = "mock-token-for-admin";
//             sessionStorage.setItem("user", JSON.stringify(userData));
//             sessionStorage.setItem("authToken", token);
//             setSuccess("Login successful!");
//             setError("");
//             navigate("/admindashboard-admindashboard");
//             return;
//         }

//         try {
//             const response = await fetch("https://erpapi.emedha.in/auth/api/login", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(loginData),
//             });

//             const result = await response.json();

//             if (response.ok) {
//                 const userData = result.user;
//                 const token = result.token;
//                 sessionStorage.setItem("user", JSON.stringify(userData));
//                 sessionStorage.setItem("authToken", token);
//                 setSuccess(result.message);
//                 setError("");
//                 if (userData.role === "admin") {
//                     navigate("/admindashboard-admindashboard");
//                 } else {
//                     navigate("/dashboard");
//                 }
//             } else {
//                 setError(result.message);
//                 setSuccess("");
//             }
//         } catch (err) {
//             setError("There was an error logging in. Please try again.");
//             setSuccess("");
//         }
//     };

//     const userOptions = users.map((user) => ({
//         value: user.Emp_id,
//         label: `${user.Emp_id} -${user.Emp_Name}`,
//     }));

//     ///
//     const [whatsappNumber, setWhatsappNumber] = useState("");
//     const [otp, setOtp] = useState("");
//     const [otpCode, setOtpCode] = useState("");
//     const [step, setStep] = useState(1); // 1: Enter Number, 2: Enter OTP
//     const [message, setMessage] = useState("");

//     const sendOtp = async () => {
//         if (whatsappNumber.length !== 10) {
//             setMessage("Please enter a valid 10-digit WhatsApp number.");
//             return;
//         }

//         try {
//             const response = await axios.post(
//                 "https://erpapi.emedha.in/pages/api/api/send-otp",
//                 {
//                     whatsappNumber,
//                 }
//             );

//             if (response.data.success) {
//                 setMessage("OTP sent successfully.");
//                 setOtpCode(response.data.otpCode);
//                 setStep(2);
//             }
//         } catch (error) {
//             setMessage(error.response?.data?.error || "Error sending OTP.");
//         }
//     };

//     const verifyOtp = async () => {
//         // if (!otp || otp !== otpCode) {
//         //     setMessage("Please enter a valid OTP.");
//         //     return;
//         // }

//         try {
//             const response = await axios.post(
//                 "https://erpapi.emedha.in/pages/api/api/verify-otp",
//                 {
//                     whatsappNumber,
//                     otpCode: otp,
//                 }
//             );

//             if (response.data.success) {
//                 setMessage("OTP verified successfully!");
//                 navigate("/dashboard");
//             } else {
//                 setMessage("Invalid OTP. Try again.");
//             }
//         } catch (error) {
//             setMessage(error.response?.data?.error || "Error verifying OTP.");
//         }
//     };

//     return (

//         <div className="container d-flex justify-content-center align-items-center min-vh-100">
//     <div
//         className="form-box text-center p-4 rounded shadow-sm"
//         style={{
//             maxWidth: "400px",
//             width: "100%",
//             backgroundColor: "#dbc4a9",
//             padding: "2rem",
//             boxSizing: "border-box",
//         }}
//     >
//         <img 
//             src={A1} 
//             alt="Logo" 
//             style={{
//                 width: "60%", 
//                 maxWidth: "200px", 
//                 marginBottom: "20px"
//             }} 
//         />

//         <div className="container">
//             <h1 className="text-primary mt-3 mb-4" style={{ fontSize: "2rem" }}>
//                 WhatsApp Login
//             </h1>

//             {step === 1 ? (
//                 <>
//                     <input
//                         type="text"
//                         placeholder="Enter WhatsApp Number"
//                         value={whatsappNumber}
//                         onChange={(e) => setWhatsappNumber(e.target.value)}
//                         style={{
//                             width: "100%", 
//                             padding: "10px", 
//                             marginBottom: "15px", 
//                             borderRadius: "5px", 
//                             border: "1px solid #ccc"
//                         }}
//                     />
//                     <button 
//                         onClick={sendOtp} 
//                         style={{
//                             width: "100%", 
//                             padding: "10px", 
//                             backgroundColor: "#007bff", 
//                             color: "white", 
//                             border: "none", 
//                             borderRadius: "5px",
//                             cursor: "pointer"
//                         }}
//                     >
//                         Send OTP
//                     </button>
//                 </>
//             ) : (
//                 <>
//                     <input
//                         type="text"
//                         placeholder="Enter OTP"
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                         style={{
//                             width: "100%", 
//                             padding: "10px", 
//                             marginBottom: "15px", 
//                             borderRadius: "5px", 
//                             border: "1px solid #ccc"
//                         }}
//                     />
//                     <button 
//                         onClick={verifyOtp} 
//                         style={{
//                             width: "100%", 
//                             padding: "10px", 
//                             backgroundColor: "#007bff", 
//                             color: "white", 
//                             border: "none", 
//                             borderRadius: "5px",
//                             cursor: "pointer"
//                         }}
//                     >
//                         Verify OTP
//                     </button>
//                 </>
//             )}

//             {message && <p>{message}</p>}
//         </div>

//         <div className="forgot-link mb-3">
//             <Link to="/" style={{ color: 'black' }}>Login</Link>
//         </div>
//     </div>

//     {/* Inline styles for responsiveness */}
//     <style>
//         {`
//             @media (max-width: 576px) {
//                 .form-box {
//                     max-width: 90% !important;
//                     padding: 1rem !important;
//                 }

//                 h1 {
//                     font-size: 1.5rem;
//                 }

//                 img {
//                     width: 50%;
//                 }
//             }
//         `}
//     </style>
// </div>

//     );
// };

// export default WhatsappLogin;



import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import A1 from "../Images/logo-w.png";
import axios from "axios";

const WhatsappLogin = () => {
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [otpCode, setOtpCode] = useState("");
    const [step, setStep] = useState(1); // 1: Enter Number, 2: Enter OTP
    const [message, setMessage] = useState("");
    const [users, setUsers] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://erpapi.emedha.in/pages/api/user");
                const result = await response.json();
                if (response.ok) {
                    setUsers(result.users);
                } else {
                    setError("Error fetching users");
                }
            } catch (err) {
                setError("There was an error fetching the users");
            }
        };
        fetchUsers();
    }, []);

    const sendOtp = async () => {
        if (whatsappNumber.length !== 10) {
            setMessage("Please enter a valid 10-digit WhatsApp number.");
            return;
        }

        try {
            const response = await axios.post("https://erpapi.emedha.in/pages/api/api/send-otp", {
                whatsappNumber,
            });

            if (response.data.success) {
                setMessage("OTP sent successfully.");
                setOtpCode(response.data.otpCode); // Store OTP for verification
                setStep(2);
            }
        } catch (error) {
            setMessage(error.response?.data?.error || "Error sending OTP.");
        }
    };

    // const verifyOtp = async () => {
    //     if (!otp ) {
    //         setMessage("Please enter a valid OTP.");
    //         return;
    //     }

    //     try {
    //         const response = await axios.post("https://erpapi.emedha.in/pages/api/api/verify-otp", {
    //             whatsappNumber,
    //             otpCode: otp,
    //         });

    //         if (response.data.success) {
    //             setMessage("OTP verified successfully!");

    //             const userData = response.data.user;

    //             if (userData) {
    //                 // const userData = result.user;
    //                 const token = "mock-token-for-user"; // You can replace this with actual token if needed
    //                 sessionStorage.setItem("user", JSON.stringify(userData));
    //                 sessionStorage.setItem("authToken", token);

    //                 navigate("/dashboard");
    //             } else {
    //                 setError("User not found with this WhatsApp number.");
    //             }
    //         } else {
    //             setMessage("Invalid OTP. Try again.");
    //         }
    //     } catch (error) {
    //         setMessage(error.response?.data?.error || "Error verifying OTP.");
    //     }
    // };

    const verifyOtp = async () => {
        if (!otp) {
            setMessage("Please enter a valid OTP.");
            return;
        }

        try {
            const response = await axios.post("https://erpapi.emedha.in/pages/api/api/verify-otp", {
                whatsappNumber,
                otpCode: otp,
            });

            // Check if the message indicates success
            if (response.data.message === "OTP verified successfully") {
                setMessage("OTP verified successfully!");

                const userData = response.data.user;

                if (userData) {
                    // Assuming the token is a mock token for now, replace it with actual token if needed
                    const token = "mock-token-for-user";

                    // Store user data and auth token in session storage
                    sessionStorage.setItem("user", JSON.stringify(userData));
                    sessionStorage.setItem("authToken", token);

                    // Navigate to the dashboard
                    navigate("/dashboard");
                } else {
                    setError("User not found with this WhatsApp number.");
                }
            } else {
                // In case the message is not success, show an error
                setMessage("Invalid OTP. Try again.");
            }
        } catch (error) {
            // Handle errors from the API request
            setMessage(error.response?.data?.error || "Error verifying OTP.");
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div
                className="form-box text-center p-5 rounded shadow"
                style={{
                    maxWidth: "400px",
                    width: "100%",
                    backgroundColor: "#ffffff",
                    padding: "2rem",
                    boxSizing: "border-box",
                    borderRadius: "10px",
                    border: "1px solid #ffffff",
                }}
            >
                <img
                    src={A1}
                    alt="Logo"
                    style={{
                        width: "60%",
                        maxWidth: "200px",
                        marginBottom: "20px",
                    }}
                />

                <div className="container">
                    <h1 className="text-primary mt-3 mb-4" style={{ fontSize: "1.5rem" }}>
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Use your WhatsApp icon here
                            alt="WhatsApp Icon"
                            width="40"
                            height="40"
                        />
                        WhatsApp Login
                    </h1>

                    {step === 1 ? (
                        <>
                            <input
                                type="text"
                                placeholder="Enter WhatsApp Number"
                                value={whatsappNumber}
                                onChange={(e) => setWhatsappNumber(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <button
                                onClick={sendOtp}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Send OTP
                            </button>
                        </>
                    ) : (
                        <>
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <button
                                onClick={verifyOtp}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Verify OTP
                            </button>
                        </>
                    )}

                    {message && <p>{message}</p>}
                    {error && <p className="text-danger">{error}</p>}
                </div>

                <div className="forgot-link mb-3">
                    <Link to="/" style={{ color: "black" }}>
                        Login
                    </Link>
                </div>
            </div>

            {/* Inline styles for responsiveness */}
            <style>
                {`
                    @media (max-width: 576px) {
                        .form-box {
                            max-width: 90% !important;
                            padding: 1rem !important;
                        }

                        h1 {
                            font-size: 1.5rem;
                        }

                        img {
                            width: 50%;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default WhatsappLogin;
